var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrap"},[_c('av-waveform',{staticClass:"wave-form",attrs:{"audio-src":_vm.URL,"canv-width":1024,"canv-height":480,"noplayed-line-color":"black","noplayed-line-width":1.5}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }